import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import Home from "./pages/Home";
import Restaurant from "./pages/Restaurant";
import { BrowserRouter, Routes, Route } from "react-router";
import RestaurantMenu from "./pages/RestaurantMenu";
import SearchFood from "./pages/SearchFood";
import SecondaryHome from "./pages/SecondaryHome";
import { store } from "./store/stores";
import {Provider} from "react-redux"
import Checkout from "./pages/Checkout";
import SignIn from "./pages/SignIn";
import { PROXY_SERVER } from "./utils/config";

function App(){

    // Warm up the proxy's DNS/TLS ahead of time so the first real request
    // (e.g. clicking "Browse restaurants") isn't stuck behind a cold lookup.
    useEffect(()=>{
        fetch(PROXY_SERVER + "health").catch(()=>{});
    },[])

    return(
       <>
       <Provider store={store}>
       <BrowserRouter>
       <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route element={<SecondaryHome></SecondaryHome>}>
        <Route path="/restaurant" element={<Restaurant></Restaurant>}></Route>
        <Route path="/city/delhi/:id" element={<RestaurantMenu></RestaurantMenu>}></Route>
        <Route path="/city/delhi/:id/search" element={<SearchFood></SearchFood>}></Route>
        <Route path="/Checkout" element={<Checkout></Checkout>}></Route>
        <Route path="/signin" element={<SignIn></SignIn>}></Route>
        </Route>
       </Routes>
       </BrowserRouter>
       </Provider>
       </>
    )
}

ReactDOM.createRoot(document.getElementById('root')).render(<App></App>);

